module.exports = __webpack_public_path__ + "82143377cfbc06daf6f0c595d95bb42d.pdf";